import { Attributes, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class SuperSetCriteria extends Model.CriteriaBase {
    static typeName = "SuperSetCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = null;

    public useNitAccountNumbers: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Super Set Criteria";
    }
}